import WalletLandingPageWrapper from './WalletLandingPageWrapper';

export default WalletLandingPageWrapper;
